import { AIStore, PromptType } from './types';

const initialState: AIStore = {
  genres: [],
  primaryGenre: null,
  microGenre: null,
  currentTrack: null,
  tracks: {},
  formula: [],
  isFormulaDrawerOpened: false,
  infoGuide: null,
  structures: [],
  promptType: PromptType.AdvancedFormula,
  textPrompt: '',
  placeholderPrompt: '',
};

export default initialState;
